import { Link } from "react-router";
import { FeedTag } from "@routes/Keyword/utils/types";
import { cn } from "@util/helpers";

export type StoryThreadProps = {
  /** Story thread data */
  storyThread: FeedTag;
  /** Optional additional styling for the container*/
  className?: string;
};

/**
 * CardStoryThread component that renders a link to a story thread.
 */
const CardStoryThread = ({
  className,
  storyThread,
}: StoryThreadProps): React.ReactElement => {
  return (
    <Link
      className={cn(
        "font-poppins text-4xs font-light uppercase leading-150 tracking-px hover:underline",
        className
      )}
      to={storyThread.urlPath}
      target="_blank"
      title={storyThread.name}
      reloadDocument
      data-testid="card-story-thread-link-component"
    >
      <span className="inline-block hover:underline">{storyThread.name}</span>
    </Link>
  );
};

export default CardStoryThread;
